module.exports = __webpack_public_path__ + "static/media/dw-black.5b7109f4.svg";